import { css } from 'lit'

export const baseCss = css`
  * {
    box-sizing: border-box;
  }

  .il-component {
    font-family: var(--il-font-family-default);
    font-size: var(--il-font-size-default);
  }

  .il-component * {
    font-family: inherit;
  }

  .il-component__loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: var(--il-color-neutrals-0);
  }

  /* pre-built font classes */
  .il-font-header-20 {
    font-size: var(--il-font-size-20);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-125);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-xbold-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-xbold-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-xbold-12 {
    font-size: var(--il-font-size-12);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-1);
  }

  .il-font-paragraph-xbold-10 {
    font-size: var(--il-font-size-10);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-150);
  }

  .il-font-paragraph-bold-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-125);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-bold-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-bold-12 {
    font-size: var(--il-font-size-12);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-1);
  }

  .il-font-paragraph-bold-10 {
    font-size: var(--il-font-size-10);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-150);
  }

  .il-font-paragraph-normal-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-normal-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-paragraph-normal-12 {
    font-size: var(--il-font-size-12);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-1);
  }

  .il-font-paragraph-normal-10 {
    font-size: var(--il-font-size-10);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
  }

  .il-font-component-xbold-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-125);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-component-bold-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-125);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-component-xbold-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-xbold);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-component-bold-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-bold);
    line-height: var(--il-font-line-height-140);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-component-normal-16 {
    font-size: var(--il-font-size-16);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  .il-font-component-normal-14 {
    font-size: var(--il-font-size-14);
    font-weight: var(--il-font-weight-normal);
    line-height: var(--il-font-line-height-150);
    letter-spacing: var(--il-font-letter-spacing-2);
  }

  /* special texts */

  .il-font-link {
    color: var(--il-color-accent-300);
  }

  .markdown p:first-of-type {
    margin-top: 0;
  }

  .markdown p:last-of-type {
    margin-bottom: 0;
  }

  /* skeleton loader styles */
  @keyframes skeleton-shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .il-skeleton {
    background: linear-gradient(
      90deg,
      var(--il-color-neutrals-100) 25%,
      var(--il-color-neutrals-50) 50%,
      var(--il-color-neutrals-100) 75%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
  }
`
